import React from 'react';
import { ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import { ScreenHeader } from '@/components/layout/ScreenHeader';
import { VStack } from '~/components/gluestack/vstack';
import { Card } from '~/components/gluestack/card';
import SafetySettingsContent from '@/components/domain/common/SafetySettingsContent';

export default function SafetySettings() {
  const { t } = useTranslation();

  return (
    <>
      <ScreenHeader options={{ title: t('settings.safety.title') }} />
      <ScrollView>
        <VStack className="mx-auto w-full max-w-4xl p-3 md:pt-0" space="md">
          <Card className="gap-3" size="md">
            <SafetySettingsContent />
          </Card>
        </VStack>
      </ScrollView>
    </>
  );
}

